const StickyNoteType = {
    STANDARD: "STANDARD",
    BUSINESS_ENTITY: "BUSINESS_ENTITY",
}

export default StickyNoteType;